import BottomCopyright from './src/bottom-copyright.vue'

export default BottomCopyright
